import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface WaveLinesProps {
    className?: string
    lines?: number
}

/*
 * Decorative contour waves. Purely visual, hidden from screen readers.
 */
const WaveLines: FC<WaveLinesProps> = ({ className, lines = 7 }): ReactNode => {
    const rows = Array.from({ length: lines }, (_, index) => index)
    const gap = 200 / (lines + 1)

    return (
        <svg
            viewBox='0 0 400 200'
            preserveAspectRatio='none'
            aria-hidden='true'
            className={cn('pointer-events-none', className)}
            fill='none'
            stroke='currentColor'
            strokeWidth='1.5'
            vectorEffect='non-scaling-stroke'
        >
            {rows.map(row => {
                const y = gap * (row + 1)
                const lift = row % 2 === 0 ? 12 : 8

                return (
                    <path
                        key={row}
                        d={`M-20 ${y} C 40 ${y - lift}, 80 ${y + lift}, 140 ${y} S 240 ${y - lift}, 300 ${y} S 400 ${y + lift}, 440 ${y}`}
                        vectorEffect='non-scaling-stroke'
                    />
                )
            })}
        </svg>
    )
}

export default WaveLines
